import { render, staticRenderFns } from "./cardChangeHistoryDialog.vue?vue&type=template&id=13c823ca&scoped=true"
import script from "./cardChangeHistoryDialog.vue?vue&type=script&lang=js"
export * from "./cardChangeHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./cardChangeHistoryDialog.vue?vue&type=style&index=0&id=13c823ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c823ca",
  null
  
)

export default component.exports